import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { JsxStyleProps } from '@repo/pandacss/types';
import { Skeleton } from '@repo/ui/Skeleton';
const styles = {
  root: css({
    display: {
      base: 'flex',
      _pcMd: 'none'
    },
    flexDirection: 'column',
    position: 'relative',
    mb: '3.5',
    borderWidth: '[1px]',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    borderRadius: 'md',
    width: '[100%]'
  }),
  innerDefault: css({
    display: 'flex',
    flexDirection: 'column',
    px: '3',
    pt: '3',
    pb: '3',
    gap: '3',
    width: '[100%]'
  }),
  innerPhase2: css({
    display: 'flex',
    flexDirection: 'column',
    px: '[0.75rem]',
    pt: '[0.75rem]',
    pb: '3',
    gap: '3',
    width: '[100%]'
  }),
  spotlightRow: css({
    display: 'flex',
    alignItems: 'center',
    mb: '2',
    width: '[100%]'
  }),
  fullWidthRow: css({
    width: '[100%]'
  }),
  imageRow: css({
    display: 'flex',
    alignItems: 'center',
    columnGap: '3',
    mb: '2',
    width: '[100%]'
  }),
  imageInfoColumn: css({
    display: 'flex',
    flexDirection: 'column',
    gap: '2'
  }),
  applyColumn: css({
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2'
  }),
  driverRow: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: '3',
    width: '[100%]'
  }),
  driverCell: css({
    flex: '1'
  }),
  accordionRow: css({
    display: 'flex',
    width: '[100%]',
    borderTopWidth: '[1px]',
    borderTopStyle: 'solid',
    borderTopColor: 'grey.200',
    py: '[0.75rem]'
  })
} as const;
const roundedSkeleton = (sizeCss: JsxStyleProps['css']) => <Skeleton variant="rounded" css={sizeCss} />;
export function MobileSkeleton(t0) {
  const $ = _c(15);
  const {
    isDriverGroupImprovementsPhase2ExperimentEnabled: t1
  } = t0;
  const isDriverGroupImprovementsPhase2ExperimentEnabled = t1 === undefined ? false : t1;
  const innerClassName = isDriverGroupImprovementsPhase2ExperimentEnabled ? styles.innerPhase2 : styles.innerDefault;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[100%]",
        height: "[40px]"
      })}</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[250px]",
        height: "[25px]"
      })}</div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = roundedSkeleton({
      width: "[150px]",
      height: "[90px]"
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.imageRow}>{t4}<div className={styles.imageInfoColumn}>{roundedSkeleton({
          width: "[125px]",
          height: "[15px]"
        })}{roundedSkeleton({
          width: "[125px]",
          height: "[15px]"
        })}{roundedSkeleton({
          width: "[120px]",
          height: "[20px]"
        })}</div></div>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.fullWidthRow}><div className={styles.applyColumn}>{roundedSkeleton({
          width: "[100%]",
          height: "[45px]"
        })}{roundedSkeleton({
          width: "[250px]",
          height: "[15px]"
        })}{roundedSkeleton({
          width: "[125px]",
          height: "[15px]"
        })}</div></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.driverRow}>{[0, 1, 2].map(_temp)}</div>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[100%]",
        height: "[70px]"
      })}</div>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[100%]",
        height: "[60px]"
      })}</div>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[100%]",
        height: "[50px]"
      })}</div>;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className={styles.fullWidthRow}>{roundedSkeleton({
        width: "[100%]",
        height: "[50px]"
      })}</div>;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== innerClassName) {
    t12 = <div className={innerClassName}>{t2}{t3}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</div>;
    $[10] = innerClassName;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [0, 1, 2].map(_temp2);
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== t12) {
    t14 = <div className={styles.root}>{t12}{t13}</div>;
    $[13] = t12;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
}
function _temp2(idx) {
  return <div key={`accordion-${idx}`} className={styles.accordionRow}>{roundedSkeleton({
      width: "[30px]",
      height: "[25px]",
      ml: "3",
      mr: "2"
    })}{roundedSkeleton({
      width: "[250px]",
      height: "[25px]"
    })}</div>;
}
function _temp(n) {
  return <div key={n} className={styles.driverCell}>{roundedSkeleton({
      width: "[100%]",
      height: "[90px]"
    })}</div>;
}